/**
 * Centralized logging utility
 * Replaces console.log/warn/error with environment-aware logging
 */
/* eslint-disable no-console -- this module is the sanctioned console wrapper */

const isDevelopment = process.env.NODE_ENV === 'development';

const logger = {
  /**
   * Log informational messages (only in development)
   */
  log: (...args) => {
    if (isDevelopment) {
      console.log('[LOG]', ...args);
    }
  },

  /**
   * Log informational messages (alias for log, only in development)
   */
  info: (...args) => {
    if (isDevelopment) {
      console.log('[INFO]', ...args);
    }
  },

  /**
   * Log warning messages (only in development)
   */
  warn: (...args) => {
    if (isDevelopment) {
      console.warn('[WARN]', ...args);
    }
  },

  /**
   * Log error messages (always logged, formatted for production)
   */
  error: (...args) => {
    // Always log errors, but format them properly
    const timestamp = new Date().toISOString();
    console.error(`[ERROR ${timestamp}]`, ...args);
    
    // In production, you might want to send to error tracking service
    if (!isDevelopment) {
      // Example: Send to error tracking service (Sentry, LogRocket, etc.)
      // errorTrackingService.captureException(new Error(args.join(' ')));
    }
  },

  /**
   * Log debug messages (only in development)
   * Can be used to silence expected errors
   */
  debug: (...args) => {
    // Always log debug in development, but silently in production
    if (isDevelopment) {
      console.debug('[DEBUG]', ...args);
    }
    // In production, debug messages are completely silent
  },

  /**
   * Log API requests (only in development)
   */
  api: (method, url, data = null) => {
    if (isDevelopment) {
      console.log(`[API ${method}]`, url, data ? { data } : '');
    }
  }
};

export default logger;

